import { render } from "./VF-card.vue?vue&type=template&id=62c41cd7"
import script from "./VF-card.vue?vue&type=script&lang=js"
export * from "./VF-card.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__